module.exports = __webpack_public_path__ + "img/players-mobile-2.507bdbab.png";